export type BusinessTypeLabelKey =
  | "create_business_identity_business_type_sas"
  | "create_business_identity_business_type_sa"
  | "create_business_identity_business_type_llc"
  | "create_business_identity_business_type_corp"
  | "create_business_identity_business_type_sociedad_anonima"
  | "create_business_identity_business_type_sociedad_limitada"
  | "create_business_identity_business_type_corporacion"
  | "create_business_identity_business_type_sa_de_cv"
  | "create_business_identity_business_type_s_de_rl_de_cv"
  | "create_business_identity_business_type_sapi_de_cv"
  | "create_business_identity_business_type_sc"
  | "create_business_identity_business_type_persona_fisica_ae";

export interface BusinessTypeOption {
  value: string;
  labelKey: BusinessTypeLabelKey;
}

const DEFAULT_BUSINESS_TYPES: readonly BusinessTypeOption[] = [
  { value: "S.A.S.", labelKey: "create_business_identity_business_type_sas" },
  { value: "S.A.", labelKey: "create_business_identity_business_type_sa" },
  { value: "LLC", labelKey: "create_business_identity_business_type_llc" },
  { value: "Corp", labelKey: "create_business_identity_business_type_corp" },
  { value: "Sociedad Anónima", labelKey: "create_business_identity_business_type_sociedad_anonima" },
  { value: "Sociedad Limitada", labelKey: "create_business_identity_business_type_sociedad_limitada" },
  { value: "Corporación", labelKey: "create_business_identity_business_type_corporacion" },
];

const BUSINESS_TYPES_BY_COUNTRY: Partial<Record<string, readonly BusinessTypeOption[]>> = {
  MEX: [
    { value: "S.A. de C.V.", labelKey: "create_business_identity_business_type_sa_de_cv" },
    { value: "S. de R.L. de C.V.", labelKey: "create_business_identity_business_type_s_de_rl_de_cv" },
    { value: "S.A.P.I. de C.V.", labelKey: "create_business_identity_business_type_sapi_de_cv" },
    { value: "S.A.", labelKey: "create_business_identity_business_type_sa" },
    { value: "S.C.", labelKey: "create_business_identity_business_type_sc" },
    {
      value: "Persona física con actividad empresarial",
      labelKey: "create_business_identity_business_type_persona_fisica_ae",
    },
  ],
};

export const businessTypesFor = (country: string): readonly BusinessTypeOption[] =>
  BUSINESS_TYPES_BY_COUNTRY[country] ?? DEFAULT_BUSINESS_TYPES;
